<template>
  <v-container pb-0>
    <v-row align="center" justify="center" dense no-gutters align-content="center">
      <v-col cols="2" align-self="center">
        <img left class="backButton" src="/static/back.png" id="back" @click="goBack"  v-show="shouldBackDisplay"/>
      </v-col>
      <v-col cols="8" align-self="center">
        <div class="logoWrapper" align="center">
          <v-img center class="liliSmallLogo" src="/static/logo-1@3x.png" v-show="shouldLogoDisplay"/>
        </div>
      </v-col>
      <v-col cols="2" align-self="center">
      </v-col>
    </v-row>
    <v-row align="center" justify="start">
      <v-col cols="12">
        <v-progress-linear background-color="#e7e7e8" color="#35d6ed"
                           v-model="progressPercent"></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    showLogo: true,
    showBack: true,
    progress: null,
    mobile: true,
    liliBrowser: false
  },
  computed: {
    shouldBackDisplay () {
      return this.showBack === undefined || this.showBack
    },
    shouldLogoDisplay () {
      return this.showLogo === undefined || this.showLogo
    },
    progressPercent () {
      return this.progress * 10
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
  .backButton {
    width: 18px;
    height: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/template/templateDesktop.vue